<div class="form-div">
  <!-- Logo -->
  <div class="text-center">
    <img
      class="logo-img"
      [src]="'assets/flyplus/app-logo.svg' | assets"
      alt="Fly+ logo"
    />
  </div>

  <!-- Progress Bars -->
  <div class="my-3 px-0">
    <div class="row">
      <div class="col-sm-12">
        <div class="row bars-row">
          @for (_ of [1, 2, 3, 4, 5]; track _; let i = $index) {
            <div class="col">
              <div class="progress" style="height: 5px" placement="bottom">
                <div
                  class="progress-bar"
                  role="progressbar"
                  [ngClass]="{
                    'in-progress-bar': i < step - 1,
                    'progress-bar-striped progress-bar-animated':
                      i === step - 1,
                  }"
                  [ngStyle]="{ width: '100%' }"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- STEP 1: Basic Info -->
  @if (step === 1) {
    <form
      [formGroup]="registrationForm.get('basic')"
      (ngSubmit)="nextFromBasic()"
      novalidate
      appTrackForm
    >
      <div class="mt-3 text-center">
        <h5 class="fw-700" translate>Register Account</h5>
        <p class="sub-label" translate>Together.. we are changing movement</p>
      </div>
      <div class="login-fields d-flex flex-column">
        <div class="row">
          <!-- First Name -->
          <div class="col-sm-6">
            <mat-label translate>First Name</mat-label>
            <mat-form-field
              class="w-100"
              [hideRequiredMarker]="true"
              appearance="outline"
              subscriptSizing="dynamic"
            >
              <input
                matInput
                formControlName="firstName"
                autocomplete="given-name"
                [placeholder]="'First Name' | translate"
                required
              />
              <mat-error>
                @if (
                  registrationForm.get('basic.firstName')?.hasError('required')
                ) {
                  <span translate>First name is required</span>
                } @else {
                  <span translate>Invalid Value</span>
                }
              </mat-error>
            </mat-form-field>
          </div>
          <!-- Last Name -->
          <div class="col-sm-6">
            <mat-label translate>Last Name</mat-label>
            <mat-form-field
              class="w-100"
              [hideRequiredMarker]="true"
              appearance="outline"
              subscriptSizing="dynamic"
            >
              <input
                matInput
                formControlName="lastName"
                autocomplete="family-name"
                [placeholder]="'Last Name' | translate"
                required
              />
              <mat-error>
                @if (
                  registrationForm.get('basic.lastName')?.hasError('required')
                ) {
                  <span translate>Last name is required</span>
                } @else {
                  <span translate>Invalid Value</span>
                }
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <!-- Birth Date -->
        <div>
          <mat-label translate>Birth Date</mat-label>
          <mat-form-field
            [hideRequiredMarker]="true"
            appearance="outline"
            subscriptSizing="dynamic"
            class="w-100"
          >
            <input
              matInput
              [matDatepicker]="picker"
              formControlName="birthDate"
              [placeholder]="'MM/DD/YYYY (e.g., 04/28/1990)' | translate"
              required
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker
              #picker
              [startAt]="defaultBirthDate"
            ></mat-datepicker>
            <mat-error>
              @if (
                registrationForm.get('basic.birthDate')?.hasError('required')
              ) {
                <span translate>Birth Date is required</span>
              } @else {
                <span>
                  {{
                    'AGE_REQUIREMENT'
                      | translate
                        : {
                            requiredAge:
                              registrationForm.get('basic.birthDate')?.errors
                                ?.minAge?.requiredAge,
                          }
                      | numberTranslate
                  }}
                </span>
              }
            </mat-error>
          </mat-form-field>
        </div>
        <!-- Email -->
        <div>
          <mat-label translate>Email Address</mat-label>
          <mat-form-field
            [hideRequiredMarker]="true"
            appearance="outline"
            subscriptSizing="dynamic"
            class="w-100"
          >
            <input
              matInput
              type="email"
              formControlName="email"
              autocomplete="email"
              [placeholder]="'Email Address' | translate"
              required
            />
            <mat-error>
              <span translate>Please enter a valid email</span>
            </mat-error>
          </mat-form-field>
        </div>
        <mat-checkbox
          color="primary"
          formControlName="termsAccepted"
          class="tnc-checkbox"
        >
          <span class="tnc-text">
            {{ 'terms_consent_prefix' | translate }}
            <a
              [href]="termsAndConditions?.link"
              target="_blank"
              rel="noopener noreferrer"
              >{{ 'Terms and Conditions' | translate }}</a
            >
            {{ 'and' | translate }}
            <a
              [href]="privacyPolicy?.link"
              target="_blank"
              rel="noopener noreferrer"
              >{{ 'Privacy Policy' | translate }}</a
            >
          </span>
        </mat-checkbox>
        <button
          mat-flat-button
          color="primary"
          type="submit"
          [disabled]="registrationForm.get('basic')?.invalid || isLoading"
          appTrackClick="register-basic-info-next-btn"
          ctaType="primary"
        >
          <app-loader
            class="inline-loader"
            [isLoading]="isLoading"
          ></app-loader>
          <span translate>Next</span>
        </button>
      </div>
    </form>
  }

  <!-- STEP 2: Email OTP -->
  @if (step === 2) {
    <div class="form-div">
      <!-- Header -->
      <div class="mt-5 text-center">
        <h5 class="fw-700" translate>Please verify your email</h5>
        <p class="sub-label">
          <span translate>An OTP has been sent to</span>
          <span>{{ registrationForm.get('basic.email')!.value }}</span>
        </p>
      </div>
      <form
        [formGroup]="registrationForm.get('emailOtp')"
        novalidate
        appTrackForm
      >
        <div class="login-error" [hidden]="!error || isLoading" translate>
          OTP code is incorrect.
        </div>
        <br />
        <div class="login-fields d-flex flex-column">
          <!-- OTP inputs -->
          <ng-otp-input
            class="text-center"
            dir="ltr"
            [formCtrl]="registrationForm.get('emailOtp').get('otp')"
            [config]="otpConfig"
          ></ng-otp-input>
          <!-- Resend / Timer -->
          <div class="forgot-password my-3 text-secondary">
            <div translate>Didn't receive the OTP yet?</div>
            @if (isTimerActive) {
              <span class="fw-600">
                <span translate> Resend OTP in </span
                >{{ getTimerText(timer) | numberTranslate }}
              </span>
            }
            @if (!isTimerActive && !isLoading) {
              <a
                class="resend-otp-link c-pointer"
                (click)="resendEmailOtp()"
                translate
                >Resend OTP?</a
              >
            }
          </div>
          <!-- Verify button -->
          <button
            mat-flat-button
            color="primary"
            (click)="verifyEmail()"
            type="submit"
            [disabled]="registrationForm.get('emailOtp')?.invalid || isLoading"
            appTrackClick="register-email-otp-verify-btn"
            ctaType="primary"
          >
            <app-loader
              class="inline-loader"
              [isLoading]="isLoading"
            ></app-loader>
            <span translate>Verify OTP</span>
          </button>
        </div>
      </form>
      <!-- Powered-by footer -->
      <div class="mt-5 text-center">
        <img
          [src]="'assets/flyplus/powered-by.png' | assets"
          width="130"
          class="mt-5 mb-3"
        />
      </div>
    </div>
  }

  <!-- STEP 3: Phone -->
  @if (step === 3) {
    <div class="form-div">
      <!-- Header -->
      <div class="mt-5 text-center">
        <h5 class="fw-700" translate>Enter Your Phone Number</h5>
      </div>
      <form
        [formGroup]="registrationForm.get('phone')"
        (ngSubmit)="nextFromPhone()"
        novalidate
        appTrackForm
      >
        <div class="login-fields password d-flex flex-column">
          <mat-label translate>Phone Number</mat-label>
          <mat-form-field [hideRequiredMarker]="true" appearance="outline">
            <input
              matInput
              formControlName="phone"
              type="tel"
              autocomplete="tel"
              [placeholder]="'Phone Number' | translate"
              required
            />
            <mat-hint
              ><span translate>Hint:</span> {{ countryCode }}XXXXXXXXX</mat-hint
            >
            <mat-error>
              <span translate>Please enter a valid phone number</span>
            </mat-error>
          </mat-form-field>
          <button
            mat-flat-button
            color="primary"
            type="submit"
            [disabled]="registrationForm.get('phone')?.invalid || isLoading"
            appTrackClick="register-phone-next-btn"
            ctaType="primary"
          >
            <app-loader
              class="inline-loader"
              [isLoading]="isLoading"
            ></app-loader>
            <span translate>Next</span>
          </button>
        </div>
      </form>
    </div>
  }
  <!-- STEP 4: SMS OTP -->
  @if (step === 4) {
    <div class="form-div">
      <!-- Header -->
      <div class="mt-5 text-center">
        <h5 class="fw-700" translate>Please verify your phone number</h5>
        <p class="sub-label" translate>
          <span translate>An OTP has been sent to</span>
          <span>{{ registrationForm.get('phone.phone')!.value }}</span>
        </p>
      </div>
      <form
        [formGroup]="registrationForm.get('smsOtp')"
        novalidate
        appTrackForm
      >
        <div class="login-error" [hidden]="!error || isLoading" translate>
          OTP code is incorrect.
        </div>
        <br />
        <div class="login-fields d-flex flex-column">
          <!-- OTP inputs -->
          <ng-otp-input
            class="text-center"
            dir="ltr"
            [formCtrl]="registrationForm.get('smsOtp').get('otp')"
            [config]="otpConfig"
          ></ng-otp-input>
          <!-- Resend / Timer -->
          <div class="forgot-password my-3 text-secondary">
            <div translate>Didn't receive the OTP yet?</div>
            @if (isTimerActive) {
              <span class="fw-600">
                <span translate> Resend OTP in </span
                >{{ getTimerText(timer) | numberTranslate }}
              </span>
            }
            @if (!isTimerActive && !isLoading) {
              <a
                class="resend-otp-link c-pointer"
                (click)="resendSmsOtp()"
                translate
                >Resend OTP?</a
              >
            }
          </div>
          <!-- Verify button -->
          <button
            mat-flat-button
            color="primary"
            (click)="verifySms()"
            type="submit"
            [disabled]="registrationForm.get('smsOtp')?.invalid || isLoading"
            appTrackClick="register-sms-otp-verify-btn"
            ctaType="primary"
          >
            <app-loader
              class="inline-loader"
              [isLoading]="isLoading"
            ></app-loader>
            <span translate>Verify OTP</span>
          </button>
        </div>
      </form>
      <!-- Powered-by footer -->
      <div class="mt-5 text-center">
        <img
          [src]="'assets/flyplus/powered-by.png' | assets"
          width="130"
          class="mt-5 mb-3"
        />
      </div>
    </div>
  }

  <!-- STEP 5: Set Password -->
  @if (step === 5) {
    <form
      [formGroup]="registrationForm.get('passwordSection')"
      (ngSubmit)="finishRegistration()"
      novalidate
      appTrackForm
    >
      <div class="mt-3 text-center">
        <h5 class="fw-700" translate>Almost there…</h5>
      </div>
      <div class="login-fields password d-flex flex-column">
        <mat-label translate>Password</mat-label>
        <mat-form-field [hideRequiredMarker]="true" appearance="outline">
          <input
            matInput
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password"
            [placeholder]="'Password' | translate"
            required
          />
          <mat-icon class="c-pointer" (click)="showHidePassword()" matSuffix>
            {{ showPassword ? 'visibility' : 'visibility_off' }}
          </mat-icon>
        </mat-form-field>
        @if (
          registrationForm.get('passwordSection.password')?.touched &&
          registrationForm.get('passwordSection.password')?.invalid
        ) {
          <div class="password-field-error mat-mdc-form-field-error">
            <span translate>
              <span translate>Password should be 8 characters or more</span
              ><br />
              <span translate
                >it should contain at least 1 uppercase character</span
              ><br />
              <span translate
                >it should contain at least 1 lowercase character</span
              ><br />
              <span translate>it should contain at least 1 special letter</span
              ><br />
            </span>
          </div>
        }
        <mat-label><span translate>Confirm Password</span></mat-label>
        <mat-form-field [hideRequiredMarker]="true" appearance="outline">
          <input
            matInput
            [type]="showConfirmPassword ? 'text' : 'password'"
            formControlName="confirm"
            [placeholder]="'Re-type Password' | translate"
            required
          />
          <mat-icon
            class="c-pointer"
            (click)="showHideConfirmPassword()"
            matSuffix
          >
            {{ !showConfirmPassword ? 'visibility_off' : 'visibility' }}
          </mat-icon>
          <mat-error>
            <span translate>Passwords do not match</span>
          </mat-error>
        </mat-form-field>
        <button
          mat-flat-button
          color="primary"
          type="submit"
          [disabled]="
            registrationForm.get('passwordSection')?.invalid || isLoading
          "
          appTrackClick="register-set-password-finish-btn"
          ctaType="primary"
        >
          <app-loader
            class="inline-loader"
            [isLoading]="isLoading"
          ></app-loader>
          <span translate>Register</span>
        </button>
      </div>
    </form>
  }

  <!-- Already have account / powered-by -->
  @if (step === 1) {
    <div class="text-center fs-13 fw-400 my-3">
      <span translate>Have an account already?</span>
      <a href="/login" translate>Login</a>
    </div>
  }
  @if (step === 1) {
    <div class="mt-5 text-center">
      <img
        [src]="'assets/flyplus/powered-by.png' | assets"
        width="130"
        class="mt-5 mb-3"
      />
    </div>
  }
</div>
